import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSeoContext } from '../context/SeoContext';
import { getSeoData, PageSpecificData } from '../seo';

// Custom hook to set SEO data for a component
export const useSeo = (data: PageSpecificData = {}) => {
  const { setSeoData } = useSeoContext();
  const location = useLocation();

  // use JSON.stringify to prevent re-renders from object reference changes
  const dataString = JSON.stringify(data);

  useLayoutEffect(() => {
    const parsedData = JSON.parse(dataString);
    const seoInfo = getSeoData(location.pathname, parsedData);
    setSeoData(seoInfo);
  }, [location.pathname, dataString, setSeoData]);
};
